import createReducer from '@sift/resift/redux/createReducer';
import createActionHandlers from '@sift/resift/redux/FetchUtils/createActionHandlers';
import { Status } from '@sift/resift/models/Status';

// ------------------------------------
// Constants
// ------------------------------------
export const THEMES_CREATE_FETCH = 'THEMES_CREATE_FETCH';
export const THEMES_GET_ALL_FETCH = 'THEMES_GET_ALL_FETCH';
export const THEMES_SET_LOADING_STATE = 'THEMES_SET_LOADING_STATE';
export const THEMES_SET_PREVIEW_ID = 'THEMES_SET_PREVIEW_ID';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  ...createActionHandlers(THEMES_CREATE_FETCH),
  ...createActionHandlers(THEMES_GET_ALL_FETCH),
  [THEMES_SET_LOADING_STATE]: (state, action) => ({
    ...state,
    status: action.payload.status,
  }),
  [THEMES_SET_PREVIEW_ID]: (state, action) => ({
    ...state,
    previewThemeId: action.payload.previewThemeId,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  previewThemeId: undefined,
  status: new Status(),
  fetches: {},
  objects: {},
};

export default createReducer(initialState, ACTION_HANDLERS);
